//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import MdmLink from '~/components/atoms/MdmLink.vue';
import Rebound from '~/components/molecules/Editorial/Global/Rebound.vue';
export default {
  name: 'Rebounds',
  components: {
    TitleSection,
    SubtitleSection,
    SimpleParagraph,
    MdmLink,
    Rebound
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24;

      return {
        title: ((_ref24 = this.payload) != null ? (_ref24 = _ref24.primary) != null ? (_ref24 = _ref24.title) != null ? _ref24[0] : _ref24 : _ref24 : _ref24) || {},
        titleColor: ((_ref23 = this.payload) != null ? (_ref23 = _ref23.primary) != null ? _ref23.title_color : _ref23 : _ref23) || '',
        subtitle: ((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? (_ref22 = _ref22.subtitle) != null ? _ref22[0] : _ref22 : _ref22 : _ref22) || {},
        subtitleColor: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? _ref21.subtitle_color : _ref21 : _ref21) || '',
        paragraph: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? _ref20.paragraph : _ref20 : _ref20) || [],
        readMore: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.read_more : _ref19 : _ref19) === 'Yes',
        button: {
          text: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.button_text : _ref18 : _ref18) || '',
          url: ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? (_ref17 = _ref17.button_url) != null ? _ref17.url : _ref17 : _ref17 : _ref17) || '',
          tracking: {
            data: {
              event_category: ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.event_category : _ref16 : _ref16) || '',
              event_action: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.event_action : _ref15 : _ref15) || '',
              event_label: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.event_label : _ref14 : _ref14) || ''
            }
          }
        },
        selections: this.payload.items.map(i => {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;

          return {
            image: {
              small: formatPrismicImage((_ref13 = i) != null ? (_ref13 = _ref13.image) != null ? _ref13.url : _ref13 : _ref13, ['w_230']) || EMPTY_PIXEL,
              medium: formatPrismicImage((_ref12 = i) != null ? (_ref12 = _ref12.image) != null ? _ref12.url : _ref12 : _ref12, ['w_230,dpr_2']) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref11 = i) != null ? (_ref11 = _ref11.image) != null ? _ref11.url : _ref11 : _ref11, ['w_375,dpr_2']) || EMPTY_PIXEL,
              xlarge: formatPrismicImage((_ref10 = i) != null ? (_ref10 = _ref10.image) != null ? _ref10.url : _ref10 : _ref10, ['w_430,dpr_2']) || EMPTY_PIXEL
            },
            title: ((_ref9 = i) != null ? _ref9.title : _ref9) || '',
            subtitle: ((_ref8 = i) != null ? _ref8.subtitle : _ref8) || '',
            withIcon: this.withIcon(((_ref7 = i) != null ? _ref7.with_icon : _ref7) || ''),
            disabled: this.isDisabled(((_ref6 = i) != null ? _ref6.disabled : _ref6) || ''),
            button: {
              text: ((_ref5 = i) != null ? _ref5.button_text : _ref5) || '',
              url: ((_ref4 = i) != null ? (_ref4 = _ref4.button_url) != null ? _ref4.url : _ref4 : _ref4) || '',
              tracking: {
                data: {
                  event_category: ((_ref3 = i) != null ? _ref3.event_category : _ref3) || '',
                  event_action: ((_ref2 = i) != null ? _ref2.event_action : _ref2) || '',
                  event_label: ((_ref = i) != null ? _ref.event_label : _ref) || ''
                }
              }
            }
          };
        })
      };
    }

  },
  methods: {
    withIcon(arg) {
      return arg === 'true';
    },

    isDisabled(arg) {
      return arg === 'true';
    }

  }
};